/* eslint-disable */
export default {
  forward: 'Transférer',
  cancel: 'Annuler',
  customNumber: 'No personnalisé',
} as const;

// @key: @#@"forward"@#@ @source: @#@"Forward"@#@
// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"customNumber"@#@ @source: @#@"Custom number"@#@
